module.exports = __webpack_public_path__ + "static/media/right-detail-turnout.20b7db27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/right-detail-turnout.jpg
// module id = 701
// module chunks = 0